import * as React from "react";

function useLocalStorageState<S>(
  key: string,
  defaultValue: S,
  { serialize = JSON.stringify, deserialize = JSON.parse } = {}
): [S, React.Dispatch<React.SetStateAction<S>>] {
  const [mounted, setMounted] = React.useState(false);
  const [state, setState] = React.useState<S>(defaultValue);
  const prevKeyRef = React.useRef(key);

  React.useEffect(() => {
    setMounted(true);
  }, []);
  React.useEffect(() => {
    if (mounted) {
      const valueInLocalStorage = window.localStorage.getItem(key);
      if (valueInLocalStorage && deserialize(valueInLocalStorage)) {
        setState(deserialize(valueInLocalStorage));
      } else {
        setState(
          typeof defaultValue === "function" ? defaultValue() : defaultValue
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mounted]);
  React.useEffect(() => {
    if (mounted) {
      const prevKey = prevKeyRef.current;
      if (prevKey !== key) {
        window.localStorage.removeItem(prevKey);
      }
      prevKeyRef.current = key;
      window.localStorage.setItem(key, serialize(state));
    }
  }, [key, state, serialize, mounted]);

  return [state, setState];
}

export default useLocalStorageState;
